module.exports = __webpack_public_path__ + "static/img/img-tec-02.37fec55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-tec-02.png
// module id = rnKm
// module chunks = 1